import { graphql } from '../__generated__/gql';

export const GET_PERMITS_BY_EVENT = graphql(/* GraphQL */ `
  query EventPermits($eventId: Int!) {
    permitsByEventId(eventId: $eventId) {
      taskId,
      moNumber,
      permitRequirement,
      permitNumber,
      lastKnownTaskDescription,
    }
  }
`);

export const GET_PERMITS_BY_ASSET_ID = graphql(/* GraphQL */ `
  query AssetPermits($assetId: Int!) {
    permitsByAssetId(assetId: $assetId) {
      taskId,
      timing,
      moNumber,
      eventId,
      eventDescription,
      functionalLocation,
      gocSh1,
      jobId,
      permitRequirement,
      permitWalked,
      permitNumber,
      permitOwner,
      updatedBy,
      updatedAt,
      comments,
      lastKnownTaskDescription,
    }
  }
`);

export const GET_PERMITS_BY_PERMIT_NUMBERS = graphql(/* GraphQL */ `
  query PermitsByPermitNumbers($permitNumbers: [String!]) {
    permitsByPermitNumbers(permitNumbers: $permitNumbers) {
      permitNumber
      statusComment
      title
    }
  }
`);
